import { render, staticRenderFns } from "./AtlasEmbed.vue?vue&type=template&id=31091b26&scoped=true"
import script from "./AtlasEmbed.vue?vue&type=script&lang=ts"
export * from "./AtlasEmbed.vue?vue&type=script&lang=ts"
import style0 from "./AtlasEmbed.vue?vue&type=style&index=0&id=31091b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31091b26",
  null
  
)

export default component.exports